import type { SessionRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'sessionManager'
const sessionSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const sessionRefs: SessionRefs = {
	getVisitorId: () => sessionSiteRefProvider(['getVisitorId']),
	getAppInstanceByAppDefId: () => sessionSiteRefProvider(['getAppInstanceByAppDefId']),
}
export { sessionRefs }
